import { createFileRoute } from '@tanstack/react-router';
import TemplatesListPage from '@/pages/(protected)/workspaces/[workspaceId]/templates/list';

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/templates/')({
  component: TemplatesListPage,
});
